<template>
    <b-button
        variant="primary"
        @click.stop="confirmarAlternarContrato()"
        class="ml-1"
    >
        <span>
            <i class="fa fa-refresh mr-2"></i>
            {{ titulo }}
        </span>
    </b-button>
</template>

<script>
import ContratosServicos from './ContratosServicos'

export default {
    props: {
        contrato: {
            type: Object,
            default: () => ({})
        }
    },

    data() {
        return {}
    },

    methods: {
        confirmarAlternarContrato() {
            this.$swal({
                title: 'Alternar Contrato',
                html: `Confirma <b>${this.titulo}</b>?`,
                icon: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: 'Sim',
                cancelButtonText: 'Não',
                input: 'textarea',
                inputPlaceholder: 'Informe a justificativa da ocorrência',
                inputValidator: (value) => {
                    if (!value) {
                        return 'A justificativa da ocorrência é obrigatória'
                    }
                }
            }).then((result) => {
                if (result.value) {
                    this.alternarContrato(result.value)
                }
            })
        },

        alternarContrato(justificativa) {
            this.$store.dispatch('addRequest')
            let alternarContratoDto = {
                idContrato: this.contrato.idContrato,
                justificativaOcorrencia: justificativa
            }
            ContratosServicos.alternarContrato(alternarContratoDto).then(
                (response) => {
                    if (response) {
                        if (response.success) {
                            this.$toast.success(
                                'Registro atualizado com sucesso!',
                                'OK',
                                this.$toastConfig.success
                            )
                            this.$emit('retornarParaLista')
                        } else {
                            this.$emit(
                                'atualizarMensagensErros',
                                response.errors
                            )
                        }
                    }
                    this.$store.dispatch('removeRequest')
                }
            )
        }
    },

    created() {},

    computed: {
        titulo() {
            if (
                this.contrato.ultimoContrato == true &&
                this.contrato.qtdAditivos > 1
            ) {
                return 'Alternar para o aditivo anterior'
            } else if (
                this.contrato.ultimoContrato == true &&
                this.contrato.qtdAditivos == 1
            ) {
                return 'Alternar para o contrato anterior'
            } else if (this.contrato.ultimoContrato == false) {
                return 'Alternar para o aditivo recente'
            } else {
                return 'Não definido'
            }
        }
    },

    watch: {},

    validations: {}
}
</script>
